export const INIT_AUTH = 'INIT_AUTH';

export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const REQUEST_SIGN_IN = 'REQUEST_SIGN_IN';



// WEBPACK FOOTER //
// ./src/core/auth/action-types.js